import React from "react";
import { FileText } from "lucide-react";

const Profile = () => {
	const name = "Karan Mundra";
	const email = "karanmundra97@gmail.com";
	const github = "https://github.com/karanm97";
	const about =
		"Passionate fullstack MERN developer dedicated to building efficient and scalable web applications. Experienced in React.js, Express.js, Node.js and MongoDB.";
	const linkedin = "https://www.linkedin.com/in/karanmundra/";

	const resumeUrl =
		// "https://drive.google.com/file/d/1VOGlb1m0zM1t8SzCbWqtV4oZ3sUXhqjX/view?usp=sharing";
		"https://docs.google.com/document/d/1KPMgzC5B4BqElN6p-6KXJhJ4KcCUFAdUnORB0A9TSyk/edit?usp=sharing";

	const detailsUrl =
		"https://docs.google.com/document/d/1hNfrmMnco7OkD22dz-9zDmPWWNAMgaaOQdj3u1Kt4dc/edit?usp=sharing";

	const keywords = ["MERN", "MongoDB", "Express", "React", "Node"];

	const renderHighlightedAbout = () => {
		const words = about.split(" ");
		return words.map((word, index) => {
			const cleanedWord = word.replace(/[.,]/g, "").replace("js", "");
			if (keywords.includes(cleanedWord)) {
				return (
					<span key={index} className="font-bold text-black">
						{word}{" "}
					</span>
				);
			} else {
				return <React.Fragment key={index}>{word} </React.Fragment>;
			}
		});
	};

	return (
		<div className="mx-6 sm:mx-10 py-6">
			<div className="grid grid-cols-1 sm:grid-cols-1 gap-8">
				{/* Profile Information Section */}
				<div className="flex flex-col items-center justify-center p-6 bg-white shadow-lg rounded-lg">
					<div className="text-3xl font-extrabold text-gray-800 mb-4">
						{name}
					</div>
					<p className="text-gray-600 text-center mb-4">
						{renderHighlightedAbout()}
					</p>
					<div className="flex flex-col items-center gap-4">
						<div className="flex flex-col sm:flex-row gap-4 items-center">
							<a
								href={`mailto:${email}`}
								className="text-lg text-blue-500 hover:text-blue-700"
							>
								{email}
							</a>
							<a
								href={github}
								target="_blank"
								rel="noopener noreferrer"
								className="text-lg text-blue-500 hover:text-blue-700"
							>
								GitHub
							</a>
							<a
								href={linkedin}
								target="_blank"
								rel="noopener noreferrer"
								className="text-lg text-blue-500 hover:text-blue-700"
							>
								LinkedIn
							</a>
						</div>
						<div className="flex gap-x-2">
							<a
								target="_blank"
								href={resumeUrl}
								className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200 flex items-center gap-2"
							>
								<FileText size={20} />
								View Resume
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Profile;
